import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=d61b9796&scoped=true&lang=pug&"
import script from "./Group.vue?vue&type=script&lang=ts&"
export * from "./Group.vue?vue&type=script&lang=ts&"
import style0 from "./Group.vue?vue&type=style&index=0&id=d61b9796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61b9796",
  null
  
)

export default component.exports